import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import  InputDropDownList from 'components/input/InputDropDownList';
import InputAmount from '../../../components/input/InputAmount';
import InputNumber from '../../../components/input/InputNumber';
import { useToasts } from 'react-toast-notifications';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingStateCost = ({ definition , transactionKeyList }) => {   
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));
    const [oldValue, setOldValue] = useState(definition.value);    
    const { t } = useLocale();
    const { addToast } = useToasts();
    
    const updateSetting = (jsonValue) =>{
        apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {                      
            setOldValue(jsonValue)            
            if (res && res.error){
                addToast(res.error.message, { appearance: 'error', autoDismiss : false })
            }
            else{                
                addToast(t('Breyting fyrir "') + t(definition.name) +t('" vistuð.'), { appearance: 'success' , autoDismiss : true })
            }            
        });        
    }

    const onUpdateValue = (value) => {
        let newList = [...settingValue];
        newList[value.StateFeeID-1] = value;        
        setSettingValue(newList);
    }    

    const onLookupUpdate = (value) =>{
        let newList = [...settingValue];
        console.log("newlist", value);
        newList[value.StateFeeID-1] = value;
        setSettingValue(newList);
        let jsonValue = JSON.stringify(newList);                
        if (jsonValue.localeCompare(oldValue) !== 0){
            console.log("compare", jsonValue, oldValue, jsonValue.localeCompare(oldValue));            
            updateSetting(jsonValue);     
        }
    }

    const onExit = () =>{
        let jsonValue = JSON.stringify(settingValue);        
        if (jsonValue.localeCompare(oldValue) !== 0){            
            console.log("compare", jsonValue, oldValue, jsonValue.localeCompare(oldValue));
            updateSetting(jsonValue);
        }        
    }


    return (       
    <div>            
        <div className="table-wrap form">
            <table className="table">
                <colgroup>
                    <col/>
                    <col width="120px"/>
                    <col width="120px"/>
                    <col width="120px"/>
                    <col/>
                </colgroup>
            <thead>
                <tr>
                    <th className="no-border">{t(definition.name)}</th>
                    <th className="no-border">Prósenta</th>
                    <th className="no-border">Lágmark</th>
                    <th className="no-border">Hámark</th>
                    <th className="no-border">Færslulykill</th>
                </tr>
            </thead>
            <tbody>                  
                {settingValue.map((fee, index) =>             
                    <tr key={index}>
                        <td className="no-border"><div className="form">{fee.Name}</div></td>       
                        <td className="no-border"><InputNumber min={0} onBlur={onExit} max={100} decimalScale={1} value={fee.Percentage} onChange={(value) => onUpdateValue({...fee, Percentage: value})}/></td>       
                        <td className="no-border"><InputAmount value={fee.MinFee} onBlur={onExit} onChange={(value) => onUpdateValue({...fee, MinFee: value})}/></td>       
                        <td className="no-border"><InputAmount value={fee.MaxFee} onBlur={onExit} onChange={(value) => onUpdateValue({...fee, MaxFee: value})}/></td>       
                        <td className="no-border"><InputDropDownList                          
                            list={transactionKeyList}
                            keyField="itemID"
                            displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.key+")" : ""); } }
                            defaultValue = {fee.TransactionKeyID}
                            onChange={(value) => onLookupUpdate({...fee, TransactionKeyID: (value ? Number(value) : null)})}
                            nullable={true}
                            nullableItem={ {itemID : null, name : ""} }/>  </td>       
                    </tr>
                )}                                      
            </tbody>
            </table>
        </div>                           
    </div>);
};


export default SettingStateCost;
